export * from './fileStore.service';
import { FileStoreService } from './fileStore.service';
export * from './version.service';
import { VersionService } from './version.service';
export const APIS = [FileStoreService, VersionService];
